import { Typography, TypographyProps } from "@mui/material";
import styled from "styled-components";
import YLLWLOGOPNG from "../assets/YllwFactory_wordmark_black.png";

export const SoecoHeader = (props: TypographyProps) => {
    return (
        <>
            <HeaderWrapper>
                <Logo src={YLLWLOGOPNG} />
                <StyledTypography
                    sx={{
                        fontFamily: "'Yllw Sans a1 241219', sans-serif",
                    }}
                    fontSize={14}
                    fontWeight={"500"}
                    color="#8c8c8c"
                    noWrap
                >
                    {props.children}
                </StyledTypography>
            </HeaderWrapper>
        </>
    );
};
const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 3px;
`;
const StyledTypography = styled(Typography)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Logo = styled.img`
    width: 120px;
    height: 22px;
    top: 30px;
    left: 135px;
    margin-top: 20px;
`;
